import validate from "/home/vsts/work/1/s/src/gmp-swa/node_modules/.pnpm/nuxt@3.21.11_@oxc-project+types@0.143.0_@types+node@18.19.127_@vue+compiler-sfc@3.5.41__72c8f0ae9b28338273d017ae83616528/node_modules/nuxt/dist/pages/runtime/validate.js";
import _01_45auth_45global from "/home/vsts/work/1/s/src/gmp-swa/middleware/01.auth.global.ts";
import _02_45redirect_45global from "/home/vsts/work/1/s/src/gmp-swa/middleware/02.redirect.global.ts";
import _03_45guardian_45global from "/home/vsts/work/1/s/src/gmp-swa/middleware/03.guardian.global.ts";
import _03_45persist_45query_45params_45global from "/home/vsts/work/1/s/src/gmp-swa/middleware/03.persist-query-params.global.ts";
import manifest_45route_45rule from "/home/vsts/work/1/s/src/gmp-swa/node_modules/.pnpm/nuxt@3.21.11_@oxc-project+types@0.143.0_@types+node@18.19.127_@vue+compiler-sfc@3.5.41__72c8f0ae9b28338273d017ae83616528/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  _01_45auth_45global,
  _02_45redirect_45global,
  _03_45guardian_45global,
  _03_45persist_45query_45params_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}